import * as types from 'constants/actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {

    case types.RECEIVE_USER:
      return action.user

    case types.LOGOUT:
      return initialState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js